import { useQuery, UseQueryResult } from 'react-query';
import { hasPayrollProduct } from '../../services/hasPayrollProduct';
import { handleUnauthorizedError } from '../../services/queryClient';
import {
  dispatchHasPayrollErrorEvent,
  dispatchHasPayrollEvent,
} from '../../utils/analyticsEvents/requestEvents';
import { ReactQueryKeys } from './keys';

const useHasPayrollProduct = (): UseQueryResult<boolean, Error> =>
  useQuery(ReactQueryKeys.HAS_PAYROLL_PRODUCT, hasPayrollProduct, {
    onSuccess: (data: boolean): void => {
      if (data) {
        dispatchHasPayrollEvent();
      }
    },
    onError: (error: Error): void => {
      dispatchHasPayrollErrorEvent(error.message);
      handleUnauthorizedError(error);
    },
  });

export { useHasPayrollProduct };
